export default __webpack_public_path__ + "static/greenshield_chat_2-cd83c46674ab507fdef11181634542e3.png";